"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyHttpHandler = void 0;
require("core-js/modules/es6.string.iterator");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.split");
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/callSuper.js"));
var _get2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/get.js"));
var _getPrototypeOf2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _querystringBuilder = require("@aws-sdk/querystring-builder");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _rxjs = require("rxjs");
var MyHttpHandler = exports.MyHttpHandler = /*#__PURE__*/function (_FetchHttpHandler) {
  function MyHttpHandler() {
    var _this;
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      requestTimeout = _ref.requestTimeout;
    (0, _classCallCheck2.default)(this, MyHttpHandler);
    _this = (0, _callSuper2.default)(this, MyHttpHandler, [{
      requestTimeout: requestTimeout
    }]);
    _this.myRequestTimeout = requestTimeout;
    _this.onProgress$ = new _rxjs.Subject();
    return _this;
  }
  (0, _inherits2.default)(MyHttpHandler, _FetchHttpHandler);
  return (0, _createClass2.default)(MyHttpHandler, [{
    key: "handle",
    value: function handle(request) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        abortSignal = _ref2.abortSignal;
      if (request.method === "PUT" && request.body) {
        return this.handleByXhr(request, {
          abortSignal: abortSignal
        });
      }
      return (0, _get2.default)((0, _getPrototypeOf2.default)(MyHttpHandler.prototype), "handle", this).call(this, request, {
        abortSignal: abortSignal
      });
    }
  }, {
    key: "handleByXhr",
    value: function handleByXhr(request) {
      var _this2 = this;
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        abortSignal = _ref3.abortSignal;
      var requestTimeoutInMs = this.myRequestTimeout;
      if (abortSignal && abortSignal.aborted) {
        var abortError = new Error("Request aborted");
        abortError.name = "AbortError";
        return Promise.reject(abortError);
      }
      var path = request.path;
      if (request.query) {
        var queryString = (0, _querystringBuilder.buildQueryString)(request.query);
        if (queryString) {
          path += "?".concat(queryString);
        }
      }
      var port = request.port,
        method = request.method;
      var url = "".concat(request.protocol, "//").concat(request.hostname).concat(port ? ":".concat(port) : "").concat(path);
      var body = method === "GET" || method === "HEAD" ? undefined : request.body;
      var requestOptions = {
        body: body,
        headers: new Headers(request.headers),
        method: method
      };
      var myXHR = new XMLHttpRequest();
      var xhrPromise = new Promise(function (resolve, reject) {
        try {
          myXHR.responseType = "blob";
          myXHR.onload = function (progressEvent) {
            resolve({
              body: myXHR.response,
              headers: myXHR.getAllResponseHeaders().split("\n"),
              status: myXHR.status
            });
          };
          myXHR.onerror = function (progressEvent) {
            return reject(new Error(myXHR.responseText));
          };
          myXHR.onabort = function (progressEvent) {
            var abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            reject(abortError);
          };
          if (myXHR.upload) {
            myXHR.upload.onprogress = function (progressEvent) {
              return _this2.onProgress$.next({
                path: path,
                progressEvent: progressEvent
              });
            };
          }
          myXHR.open(requestOptions.method, url);
          if (requestOptions.headers) {
            requestOptions.headers.forEach(function (headerVal, headerKey, headers) {
              if (["host", "content-length"].indexOf(headerKey.toLowerCase()) >= 0) {
                return;
              }
              myXHR.setRequestHeader(headerKey, headerVal);
            });
          }
          var _body = requestOptions.body;
          myXHR.send(_body);
        } catch (e) {
          console.error("S3 XHRHandler error", e);
          reject(e);
        }
      });
      var raceOfPromises = [xhrPromise.then(function (response) {
        var fetchHeaders = response.headers;
        var transformedHeaders = {};
        fetchHeaders.forEach(function (header) {
          var name = header.substr(0, header.indexOf(":") + 1);
          var val = header.substr(header.indexOf(":") + 1);
          if (name && val) {
            transformedHeaders[name] = val;
          }
        });
        var hasReadableStream = response.body !== undefined;
        if (!hasReadableStream) {
          return response.body.text().then(function (body) {
            return {
              response: new _protocolHttp.HttpResponse({
                headers: transformedHeaders,
                statusCode: response.status,
                body: body
              })
            };
          });
        }
        return {
          response: new _protocolHttp.HttpResponse({
            headers: transformedHeaders,
            statusCode: response.status,
            body: response.body
          })
        };
      }), this.requestTimeoutFn(requestTimeoutInMs)];
      if (abortSignal) {
        raceOfPromises.push(new Promise(function (resolve, reject) {
          abortSignal.onabort = function () {
            myXHR.abort();
          };
        }));
      }
      return Promise.race(raceOfPromises);
    }
  }, {
    key: "requestTimeoutFn",
    value: function requestTimeoutFn() {
      var timeoutInMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return new Promise(function (resolve, reject) {
        if (timeoutInMs) {
          setTimeout(function () {
            var timeoutError = new Error("Request did not complete within ".concat(timeoutInMs, " ms"));
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
          }, timeoutInMs);
        }
      });
    }
  }]);
}(_fetchHttpHandler.FetchHttpHandler);